<template>
  <v-sheet rounded elevation="10" class="pb-5">
    <v-card-title>Filter</v-card-title>
    <v-card-subtitle>Select a reaction from below to sort</v-card-subtitle>
    <v-row>
      <v-col>
        <v-btn-toggle
          group
          mandatory
          active-class="grey lighten-2"
          :style="{ width: '100%' }"
          v-model="searchParams.reaction"
        >
          <v-col>
            <v-row>
              <v-col
                :cols="reaction.name == 'total' ? 12 : 4"
                v-for="(reaction, i) in reactions"
                :key="i"
              >
                <v-btn
                  plain
                  :x-large="reaction.name === 'total'"
                  min-width="100%"
                  min-height="150%"
                  class="d-flex justify-center align-center py-5"
                  :value="reaction.name"
                >
                  <span v-if="reaction.text">
                    {{ reaction.text }}
                  </span>
                  <v-avatar v-if="reaction.path" tile>
                    <v-img :src="reaction.path" />
                  </v-avatar>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-btn-toggle>
        <v-card-title>Period</v-card-title>
        <v-btn-toggle
          group
          mandatory
          active-class="grey lighten-2"
          v-model="searchParams.timeFrame"
          :style="{ width: '100%' }"
        >
          <v-col>
            <v-row justify="center">
              <v-col
                cols="4"
                v-for="(timeFrame, i) in timeFrameOptions"
                :key="i"
              >
                <v-btn text plain min-width="100%" :value="timeFrame.value">
                  <span>{{ timeFrame.name }}</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="primary"
        @click="
          {
            $emit('toggleDrawer');
            $emit('initialLoad');
          }
        "
      >
        Done
      </v-btn>
    </v-card-actions>
  </v-sheet>
</template>
<script>
export default {
  props: {
    drawer: Boolean,
    toggleDrawer: Function,
    loadPosts: Function,
    reactions: Object,
    timeFrameOptions: Array,
    searchParams: Object,
  },
};
</script>
